import { store } from "../Store/store";
import axios from "axios";
import { config, localeMap } from "../consts/constant";
const NovaAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || config.url.API_URL,
  withCredentials: true,
  headers: {
    platformType: "patient",
  },
});

NovaAPI.interceptors.request.use((request) => {
  const lang = store.getState().languageChange.language;
  request.headers["accept-language"] = localeMap(lang);
  return request;
});

export default NovaAPI;
